import Link from 'next/link';
import { colors } from '@firsttable/web-theme';
import { useAnalytics } from '@/components/analytics/hooks/useAnalytics';
import Experiment from '../experiment';
import { PD7032_HIGHLIGHT_TOP_BOOKERS_FLAG } from './flag';

const TIER_LABELS = { gold: 'Gold', platinum: 'Platinum' } as const;

const FREQUENT_FOODIES_HREF = '/profile/frequent-foodies';

type HighlightedTier = keyof typeof TIER_LABELS;

const isHighlightedTier = (tier?: string): tier is HighlightedTier =>
  !!tier && Object.hasOwn(TIER_LABELS, tier);

export default function PD7032ReviewerStatusTag({
  loyaltyStatus,
}: {
  loyaltyStatus?: string | null;
}) {
  const { track } = useAnalytics();
  const tier = loyaltyStatus?.toLowerCase();

  if (!isHighlightedTier(tier)) return null;

  const label = TIER_LABELS[tier];

  return (
    <Experiment
      flag={PD7032_HIGHLIGHT_TOP_BOOKERS_FLAG}
      control={null}
      treatment={
        <Link
          href={FREQUENT_FOODIES_HREF}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            track('link_clicked', {
              href: FREQUENT_FOODIES_HREF,
              link_type: 'reviewer status tag',
              link_name: 'frequent foodies tier',
              link_copy: label,
            })
          }
          className="ml-2 inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 align-middle text-xs font-bold text-white no-underline"
          style={{ backgroundColor: colors.loyalty[tier] }}>
          {label}
        </Link>
      }
    />
  );
}
